import type { JSX } from 'react'

// In the future we can re-use this component to show some notifications on the top of the page

// import { TopPageNotification as TopPageNotificationArcana } from "/app/libraries/arcana/src/blocks/TopPageNotification/index.ts"

// <TopPageNotificationArcana onClose={hideNotification}>
//   notification
// </TopPageNotificationArcana>

export function TopPageNotification(): JSX.Element | null {
  return null
}
